<route>
{
  "meta": {
    "hidden": true,
    "hideAside": true,
    "simple": true
  }
}
</route>

<template>
  <ConfigProvider
    :locale="locale"
    :get-holiday-func="getHolidayList"
  >
    <div id="master-container">
      <template v-if="showOverseasGuideLayout">
        <OverseasGuideLayout />
      </template>
      <template v-else>
        <IssueDetailWarper />
        <LayoutDrawerRoot v-if="showOverseasLayout" />
        <DefaultLayoutSwitcher>
          <template #default="{ show }">
            <default-layout v-if="show && showDefaultLayout" />
          </template>
        </DefaultLayoutSwitcher>

        <DelayComponent
          v-if="showSystemMessage"
          :delay="3500"
        >
          <SystemMessage />
        </DelayComponent>
        <DelayComponent :delay="1500">
          <FloatBtnBox />
        </DelayComponent>

        <DelayComponent :delay="1500">
          <SystemSubscription />
        </DelayComponent>
      </template>
    </div>
  </ConfigProvider>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import DefaultLayout from '@/layouts/default';
import { getIssueId } from '@/api/search';
import eventBus from '@/plugins/eventBus';
import { initNoticeListener } from '@/utils/notice';
import DelayComponent from '@/components/DelayComponent';
import { mapActions, mapGetters } from 'vuex';
import { loadAllLanguage } from 'common-module/src/lang';
// import dayjs from 'dayjs';
import http from 'common-module/src/util/http';
import GuideMixin from './mixins/GuideMixin';
// eslint-disable-next-line

import DefaultLayoutSwitcher from '@/layouts/DefaultLayoutSwitcher';
import issueHttp from 'common-module/src/util/http';
import OverseasGuideLayout from '@/layouts/OverseasGuideLayout';
import { isWebView, getLongLocale } from './utils';
import { reloadI18n } from 'common-module/src/util/index';
import Cookie from 'js-cookie';
import { ConfigProvider } from 'zk-date-picker';
import { getHolidayList } from './api/project';

/* eslint-disable */
                 

import { IssueDetailWarper } from 'liga-detail-en';
import { LayoutDrawerRoot } from 'liga-layout';
        
                                                
         
/* eslint-disable */

export default {
  name: 'App',
  components: {
    ConfigProvider,
    DelayComponent,
    SystemMessage: () => import('@/components/SystemMessage'),
    FloatBtnBox: () => import('@/components/float-btn/RightContent.vue'),
    SystemSubscription: () => import('@/components/SystemSubscription'),
    DefaultLayout,
    // eslint-disable-next-line vue/no-unused-components
    // eslint-disable-next-line
    IssueDetailWarper,
    // eslint-disable-next-line vue/no-unused-components
    DefaultLayoutSwitcher,
    OverseasGuideLayout,
    /* eslint-disable */
                     
    LayoutDrawerRoot
             
    /* eslint-disable */
  },
  mixins: [GuideMixin],
  metaInfo() {
    return {};
  },
  socketEvents: {
    userPermissionUpdate(data) {
      this.refreshPermission({
        refreshOrg: true,
        refreshProject: !!data.projectId
      });
    }
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  },
  computed: {
    ...mapGetters('user', [
      'userProductRights',
      'messageBannerNoticeList',
      'isAnonymous',
      'isLogin'
    ]),
    getHolidayList() {
      return !this.isLogin || this.isAnonymous ? () => [] : getHolidayList;
    },
    locale() {
      return getLongLocale(this.$i18n.locale);
    },
    allRoles() {
      return this.$store.getters.allRoles;
    },
    isNotFound() {
      return this.$route.name === '404';
    },
    isSettingPage() {
      return this.$route.path.startsWith('/setting/');
    },
    isCreateProjectPage() {
      return this.$route.path.startsWith('/project/create');
    },
    isRecorderViewPage() {
      return this.$route.path.startsWith('/work/view-recorder');
    },
    isSharePage() {
      return this.$route.meta?.share === true;
    },
    showSystemMessage() {
      return (
        !this.isNotFound &&
        !this.isSettingPage &&
        !this.isCreateProjectPage &&
        !this.isRecorderViewPage &&
        !this.isSharePage
      );
    },
    showDefaultLayout() {
      return (
        this.isLogin ||
        (this.isSharePage &&
          ['share-login', 'share-expired', '404'].includes(this.$route.name))
      );
    },
    showOverseasGuideLayout() {
      return this.$route.name === 'welcome';
    },
    showOverseasLayout() {
      return isOverseasVersion;
    }
  },
  async created() {
    const isProd = ['prod', 'sit', 'pre'].includes(this.$config.VUE_APP_ENV);
    if (!isProd && isWebView()) {
      const vConsoleModule = await import('vconsole');
      new vConsoleModule.default();
    }
    this.$meta?.().setOptions({ I: true, refreshOnceOnNavigation: true });
    window.destroyLoading?.();
  },
  mounted() {
    this.eventBus.$on('project-create', async (project) => {
      await this.changeProject(project);
      eventBus.$emit('updateNavProjectList');
      this.$router.push('/kanban/list');
    });

    this.eventBus.$on('global:update-language', async (lang) => {
      lang = lang || this.$i18n.locale;
      const locale = await reloadI18n(lang);
      Cookie.set('app_locale', locale);
      loadAllLanguage(
        this.$store.getters['user/orgId'],
        lang,
        this.$store.getters.token,
        true
      );
    });

    this.eventBus.$on('permission-change', (value, force) => {
      if (this.allRoles.length || force) {
        if (!value) {
          this.showNoPermissionAlert();
        } else {
          this.hideNoPermissionAlert();
        }
      }
    });
    this.eventBus.$on('global:404', () => {
      this.$router.push('/404');
    });
    this.eventBus.$on('global:openIssueDialog', async (type, id, extData) => {
      let event = 'issue:edit';
      if (type === 'subtask') {
        const res = await getIssueId(id);
        id = res.id;
      }
      if (type === 'epic') {
        event = 'epic:edit';
      }
      this.eventBus.$emit(event, { ...extData, id });
    });
    this.eventBus.$on('project:kanban', async (value) => {
      await this.forceChangeProject(value.id);
      eventBus.$emit('updateNavProjectList');
      this.$router.push('/kanban/list');
    });

    initNoticeListener(this.$root);
    this.initIssueUpdateInterceptor();

    setTimeout(() => {
      if (window.enablePrefetch) {
        window.enablePrefetch();
      }
    }, 5000);
  },
  methods: {
    ...mapActions('app', ['forceChangeProject', 'changeProject']),
    initIssueUpdateInterceptor() {
      // 这里主要是通过axios拦截issue更新接口调用智能助理推荐
      http.httpAxios.interceptors.request.use((config) => {
        if (['/issue/update-v2', '/issue/update'].includes(config.url)) {
          // this.eventBus.$emit('global:issueUpdate', { ...config.data });
        }
        return config;
      });
      issueHttp?.httpAxios.interceptors.request.use((config) => {
        if (['/issue/update-v2', '/issue/update'].includes(config.url)) {
          // this.eventBus.$emit('global:issueUpdate', { ...config.data });
        }
        return config;
      });
    },
    async refreshPermission(payload) {
      const { refreshOrg = false, refreshProject = false } = payload || {};
      const calls = [];
      if (refreshOrg) {
        calls.push(this.$store.dispatch('user/justLoadUserInfo'))
      }
      if (refreshProject) {
        calls.push(this.$store.dispatch('app/loadProjects', true));
      }
      await Promise.all(calls);
      this.checkCurrentRoutePermission();
    },
    checkCurrentRoutePermission() {
      const route = this.$route;
      const { notAccessFunctions } = route.meta;
      //0608新增 meta.notAccessFunctions 用于判断 没有进入页面的权限（例如：如果是项目协作者则不可以进入史诗页面）
      const hasNotEnterAccess = notAccessFunctions?.length
        ? notAccessFunctions.some(fn => !!this.option.store.getters[fn])
        : false;

      const hasAccess = this.$store.getters['user/checkAccessPermission'](route.meta);
      if (hasAccess && !hasNotEnterAccess) {
        return;
      }
      window.console.warn(`permission changed, access denied, to: ${route.path}`);
      this.showNoPermissionAlert();
    }
  }
};
</script>

<style lang="scss">
html,
body,
#app,
#master-container {
  height: 100%;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
#meiqia-container {
  #networkErr {
    display: none !important;
  }
}
</style>
